import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { TextField, Grid } from "@material-ui/core";
import Axios from "axios";
import UrlLinks from "../../../../UrlLinks";
import styles from "./components.module.scss";

const dialogTitleStyles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3.25),
    paddingBottom: theme.spacing(3),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: "18px",
    color: "#2E2E2E",
  },
});

const DialogTitle = withStyles(dialogTitleStyles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" className={styles.modalTitle}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3.25),
    paddingTop: theme.spacing(0),
    borderBottom: "unset",
  },
}))(MuiDialogContent);

const StyledTextField = withStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& fieldset": {
        borderColor: "#E4E4E4",
        borderWidth: "0.8px",
      },
      "&:hover fieldset": {
        borderColor: "#E4E4E4",
        borderWidth: "0.8px",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E4E4E4",
        borderWidth: "0.8px",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "14px 16px",
      fontSize: "14px",
      "&::placeholder": {
        color: "#757575",
        opacity: 1,
      },
    },
  },
}))(TextField);

// Column Input Row Component
const ColumnInputRow = ({ index, value }) => (
  <div className={styles.columnInputRow}>
    <span className={styles.columnNumber}>{index})</span>
    <StyledTextField
      variant="outlined"
      value={value}
      className={styles.columnInput}
      InputProps={{
        readOnly: true,
      }}
    />
  </div>
);

const InvoiceColumnsModal = ({ open, onClose, title = "", projectId }) => {
  const [localColumns, setLocalColumns] = useState([]);

  useEffect(() => {
    if (!open) return;

    if (projectId && projectId !== "add") {
      Axios.get(
        `${UrlLinks.baseUrl}${UrlLinks.paymentUrls.getCustomInvoiceTemplate}?projectId=${projectId}`
      )
        .then((response) => {
          if (response.data && response.data.code === 1000) {
            if (response.data.response?.config) {
              const config = response.data.response.config;
              const allColumns = [];

              Object.keys(config).forEach((category) => {
                const childKeys = Object.keys(config[category]);
                allColumns.push(...childKeys);
              });

              setLocalColumns(allColumns);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching invoice template:", error);
        });
    }
  }, [open]);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      classes={{
        paper: styles.invoiceColumnsModalPaper,
      }}
    >
      <DialogTitle onClose={handleClose}>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          {localColumns.map((column, index) => (
            <Grid item xs={6} key={index}>
              <ColumnInputRow index={index + 1} value={column} />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default InvoiceColumnsModal;
